import { Stack } from 'expo-router';
import React from 'react';

function OnboardingLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default OnboardingLayout;
